import AccountSelection from './AccountSelection';
import { useBank } from './useBank';
import { useAccountSelection } from './useAccountSelection';
import StepHeader from '../StepHeader';
import { ACCOUNT_SELECTION_STEP_PREFIX } from '../../utils/translationPagePrefix';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app/hooks';
import { selectAccounts } from '../../app/slices/account.slice';
import { Account } from '../../types/account';

const AccountSelectionStep = () => {
	const { t } = useTranslation();

	const accounts = useAppSelector(selectAccounts) as Array<Account>;
	const { bankName, bankCode } = useBank();
	const { selected, selectedAccount, onAccountSelect, onContinue } = useAccountSelection();
	const subtitleText = t(`${ACCOUNT_SELECTION_STEP_PREFIX}.subtitle`);
	const titleText = t(`${ACCOUNT_SELECTION_STEP_PREFIX}.title`);

	if (selected) {
		return (
			<StepHeader
				title={`${titleText} ${bankName}`}
				subtitle={subtitleText}
				bankName={bankName}
				withSpinner={true}
			/>
		);
	}

	return (
		<AccountSelection
			accounts={accounts}
			selectedAccount={selectedAccount}
			bankCode={bankCode}
			bankName={bankName}
			onAccountSelect={onAccountSelect}
			onContinue={onContinue}
		/>
	);
};

export default AccountSelectionStep;
